export default __webpack_public_path__ + "static/media/bg17.f775e7ea.jpg";